import { useMutation } from '@tanstack/react-query';
import { POST, POST_WARRANTY_UPDATE } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';
import {
  appendConfirmSimilarImage,
  appendUploadFile,
  confirmSimilarImage,
  postWithImageCheck,
  SAVE_WARNING_KEY,
  showSaveWarnings,
} from '../../../../functions/imageUpload';

export const onUploadFile = ({ onSuccessCallBack }) => {
  const mutation = useMutation({
    mutationFn: async ({
      invImageUrl,
      packageImageUrl,
      warrantyId,
      telephone,
      fullName,
      warrantyNumberCode,
      mobileBrandId,
      mobileModelId,
      mapProductId,
      channelBuyId,
      warrantyTypeId,
      storeId,
      confirmSimilarImage: isConfirmSimilarImage,
    }) => {
      const formData = new FormData();
      appendUploadFile(formData, 'invImage', invImageUrl);
      appendUploadFile(formData, 'packageImage', packageImageUrl);
      appendConfirmSimilarImage(formData, isConfirmSimilarImage);
      formData.append('warrantyId', warrantyId);
      formData.append('telephone', telephone);
      formData.append('fullName', fullName);
      formData.append('warrantyNumberCode', warrantyNumberCode);
      formData.append('mobileBrandId', mobileBrandId);
      formData.append('mobileModelId', mobileModelId);
      formData.append('mapProductId', mapProductId);
      formData.append('channelBuyId', channelBuyId);
      formData.append('warrantyTypeId', warrantyTypeId);
      formData.append('storeId', storeId);
      const response = await postWithImageCheck(() => POST(POST_WARRANTY_UPDATE(), formData));
      if (onSuccessCallBack) onSuccessCallBack(response);
      return response;
    },
    onSuccess: (response) => {
      if (showSaveWarnings(response, [SAVE_WARNING_KEY.IMAGE_HASH], () => window.location.reload()))
        return;
      openAlert({ model: 'message', type: 'success', message: 'แก้ไขข้อมูลสินค้าสำเร็จ' });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    onError: (error, variables) => {
      confirmSimilarImage(error, () =>
        mutation.mutate({ ...variables, confirmSimilarImage: true }),
      );
    },
  });
  return mutation;
};
